import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      PAGE_SEO: state => state.seo.seo,
    }),
  },

  methods: {
    getPageMeta({ pageTitle } = {}) {
      const meta = [];
      const description = this.PAGE_SEO.description || pageTitle;

      description && meta.push({
        name: 'description',
        content: description,
        vmid: 'description',
      });

      return {
        title: this.PAGE_SEO.title || pageTitle,
        meta,
      };
    },
  },
};
